// CSV download built in the browser: no endpoint, no dependency, works offline.

const cell = (v) => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  // Quote anything that could break the row; double internal quotes per RFC 4180.
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/**
 * Download rows as a CSV file.
 *
 * @param {string} filename  without extension
 * @param {Array}  columns   [{ key, label, csv? }] - csv(row) overrides the raw value, so a
 *                           column rendered as a pill can still export a plain word
 * @param {Array}  rows      array of objects
 */
export const exportCsv = (filename, columns, rows) => {
  const header = columns.map((c) => cell(c.label)).join(',');
  const lines = rows.map((r) =>
    columns.map((c) => cell(c.csv ? c.csv(r) : r[c.key])).join(',')
  );
  // The BOM makes Excel read the file as UTF-8, which keeps Urdu names intact.
  const blob = new Blob(['﻿' + [header, ...lines].join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
